'use client'

import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import type { Header } from '@/payload-types'
import { resolveHref } from '@/utilities/resolveHref'
import styles from './TopSubnav.module.css'

interface TopSubnavProps {
  data: Header['topSubnav']
}

export const TopSubnav: React.FC<TopSubnavProps> = ({ data }) => {

  // Early return if no data
  if (!data) return null

  // TopSubnav always has dark background and lime text
  return (
    <div className={`${styles.container} bg-civo-dark-gray`}>
      <div className={`${styles.inner} px-7 md:px-9 xl:px-16 py-4 max-w-[1440px] mx-auto text-civo-lime`}>
        {/* Left side - Promotional Banner */}
        <div className={styles.left}>
        {data.promotionalBanner?.enabled && (
          <>
            <svg width="14" height="13" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" aria-hidden="true">
              <g clipPath="url(#clip0)">
                <path d="M13 4.5c.276 0 .512.098.707.293A.963.963 0 0114 5.5a.963.963 0 01-.293.707A.963.963 0 0113 6.5v3a.96.96 0 01-.296.703.961.961 0 01-.704.297C9.83 8.693 7.714 7.703 5.657 7.531c-.302.1-.539.271-.71.516a1.256 1.256 0 00-.243.785c.01.279.115.52.313.723a1.2 1.2 0 00-.18.511c-.016.17 0 .32.047.454.047.132.134.276.262.43.127.153.252.283.375.39.122.107.282.238.48.394-.151.303-.441.519-.871.649s-.868.16-1.316.09c-.448-.07-.792-.215-1.031-.434-.037-.12-.114-.348-.23-.684-.118-.335-.201-.582-.25-.738a9.524 9.524 0 01-.18-.695 4.32 4.32 0 01-.118-.79 6.316 6.316 0 01.028-.769c.026-.294.083-.582.172-.863h-.953c-.344 0-.638-.122-.883-.367a1.204 1.204 0 01-.367-.883v-1.5c0-.344.122-.638.367-.883s.539-.367.883-.367h3.75c2.265 0 4.598-1 6.998-3 .271 0 .506.099.704.297A.961.961 0 0113 1.5v3zm-1 4.719V1.766C9.95 3.339 7.95 4.232 6.001 4.446v2.109c1.963.218 3.963 1.106 6 2.664z" fill="currentColor"/>
              </g>
              <defs>
                <clipPath id="clip0">
                  <path fill="#fff" transform="translate(0 .5)" d="M0 0h14v12H0z"/>
                </clipPath>
              </defs>
            </svg>
            <Link
              href={data.promotionalBanner.href || '/'}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-copy"
            >
              {data.promotionalBanner.text}
            </Link>
          </>
        )}
      </div>

      {/* Right side - Quick Links */}
      <div className={styles.right}>
        {(data.quickLinks || []).map((item, index) => (
          <Link
            key={index}
            href={resolveHref(item.link, '/')}
            target={item.link?.newTab ? '_blank' : undefined}
            rel={item.link?.newTab ? 'noopener noreferrer' : undefined}
            className="nav-copy"
          >
            {item.link?.label}
          </Link>
        ))}

        {/* Login Section */}
        <div className={styles.login}>
          <Image src="/assets-rebrand/icons/login-icon.svg" alt="Login" width={24} height={24} />
          <Link
            href={data.loginUrl || '/login'}
            className="nav-copy"
          >
            Login
          </Link>
        </div>
      </div>
      </div>
    </div>
  )
}